/**
 * Created by hcy on 2017/11/30.
 */

// refreshToken         刷新token
// imgCode              生成图片验证码
// smsCode              发送验证码
// getCode              码值表
// getIsOpenEncrypt     是否开启AES加密解密
//  sceneId:业务场景id  mobile:手机号 userId:用户id

// 调用方法  this.refreshToken ()
export default{
  install (Vue, options) {
    Vue.prototype.getIOSInfo = function (callback) {
      let self = this
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {      
        self.$bridge.callhandler('getBanerLoginInfo', {'success': 'success'}, (data) => {
          let res = data
          if (!self.$utils.isnull(res)) {
            let appInfo = JSON.parse(res)
            localStorage.banner_uid = appInfo.userId
            localStorage.banner_token = appInfo.token
            sessionStorage.banner_channel = appInfo.channel
          }
          callback && callback()
        })
        if (sessionStorage.banner_channel !== '02') {
          callback && callback()
        }
      }else{
        callback && callback()
      }
    }
    Vue.prototype.refreshToken = function () {
      this.axios.post('/baner/00_0002.do')
        .then(function (res) {
          let state = res.data.head._rd
          if (state === '0000') {
            let token = res.data.body.newToken
            localStorage.setItem('token', token)
            return token
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
    Vue.prototype.smsCode = function (sceneId, mobile, userId, cardNo) {
      this.axios.post('/baner/00_0007.do', {
        sceneId: sceneId,
        mobile: mobile,
        userId: userId
      })
      .then(function (res) {
        let state = res.data.head._rd
        if (state === '0000') {
          switch (sceneId) {
            case '005':
              let url = document.URL
              if (url.indexOf('localhost') !== -1) {
                location.href = 'http://localhost:8080/#/MyBankCard/AddBankCardC/' + cardNo + '/' + mobile + '/' + false
              } else {
                location.href = window.rootUrl + '/#/MyBankCard/AddBankCardC/' + cardNo + '/' + mobile + '/' + false
              }
              break
            case '006':
              return true
            default:
              break
          }
        }
      })
      .catch(function (error) {
        console.log(error)
      })
    }
    Vue.prototype.getCode = function () {
      this.axios.post('/baner/00_0001.do')
        .then(function (res) {
          let state = res.data.head._rd
          if (state === '0000') {
            sessionStorage.banner_code = JSON.stringify(res.data.body.params)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
    Vue.prototype.imgCode = function (sceneId, mobile, userId) {
      sessionStorage.setItem('code', '0006')
      this.axios.post('/baner/00_0006.do', {
        sceneId: sceneId,
        mobile: mobile,
        userId: userId
      })
        .then(function (res) {
          console.log(res)
          let state = res.data.head._rd
          if (state === '0000') {
            let picStr = res.data.body.picStr
            return picStr
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/publicAPI.js